import { writable } from "svelte/store";
import Auth0Lock from "auth0-lock";

export const lock = writable(
  new Auth0Lock(process.env.AUTH0__CLIENT_ID, process.env.AUTH0__DOMAIN, { configurationBaseUrl: process.env.AUTH0__CONFIG_BASE_URL || "https://cdn.auth0.com" })
);
